import {IPortalPluginEvent} from "@/pluginManager/IPortalPluginEvent";
import {PortalPluginEventHandler} from "@/pluginManager/portalPlugin";

/**
 * Dispatcher that can propagate events to subscribers.
 */
export class PortalPluginEventDispatcher<E> implements IPortalPluginEvent<E> {
    /**
     * The handlers that want to be notified when an event occurs.
     * @ignore
     */
    private readonly _handlers: PortalPluginEventHandler<E>[];

    /**
     * Create a new event dispatcher.
     */
    constructor() {
        this._handlers = [];
    }

    /**
     * Subscribes a new handler with the dispatcher. Any time the event is
     * dispatched, the handler will be notified.
     * @param handler The handler to register.
     */
    public subscribe(handler: PortalPluginEventHandler<E>): void {
        this._handlers.push(handler);
    }

    /**
     * Unsubscribes a handler from the dispatcher.
     * @param handler The handler to remove.
     */
    public unsubscribe(handler: PortalPluginEventHandler<E>): void {
        for (let i = 0; i < this._handlers.length; i++) {
            if (this._handlers[i] === handler) {
                this._handlers.splice(i, 1);
            }
        }
    }

    /**
     * Dispatch an event to all the subscribers.
     * @param event The data of the event that occured.
     */
    public dispatch(event: E): void {
        for (const handler of this._handlers) {
            handler(event);
        }
    }
}